import { AdvisorId, ADVISORS } from "../state/schema";

/* Frontend kennt NUR Berater-Kennungen und Anzeigenamen – niemals E-Mail-Adressen.
   Die Zuordnung Kennung -> E-Mail erfolgt ausschließlich serverseitig (§30). */

export function advisorLabel(id: AdvisorId): string {
  return ADVISORS.find((a) => a.id === id)?.label ?? "—";
}

export function isValidAdvisorId(id: string): id is AdvisorId {
  return ADVISORS.some((a) => a.id === id);
}
